module.exports = __webpack_public_path__ + "img/SK.008712d6.png";